import type { TooltipRenderProps } from '@fordeer/app-tour'
import { Button, ButtonGroup } from '@shopify/polaris'
import { X } from 'lucide-react'
import styles from './AppTourPolarisTooltip.module.scss'

export const AppTourPolarisTooltip = ({
  backProps,
  closeProps,
  index,
  primaryProps,
  skipProps,
  step,
  tooltipProps,
}: TooltipRenderProps) => {
  const { buttons, content, title } = step
  const showClose = buttons.includes('close')
  const showBack = buttons.includes('back') && index > 0
  const showPrimary = buttons.includes('primary')
  const showSkip = buttons.includes('skip')

  const placement = step.placement ?? 'bottom'
  const isCentered = placement === 'center'
  const [placementSide, placementAlign] = isCentered
    ? []
    : (placement.split('-') as [string, string | undefined])

  return (
    <div
      className={styles.root}
      data-app-tour-tooltip
      {...(placementSide ? { 'data-placement-side': placementSide } : {})}
      {...(placementAlign ? { 'data-placement-align': placementAlign } : {})}
      {...(step.id ? { 'data-joyride-id': step.id } : {})}
      data-joyride-step={index}
      {...tooltipProps}
    >
      <div className={styles.header}>
        {title ? <h2 className={styles.title}>{title}</h2> : <span className={styles.title} />}
        {showClose ? (
          <button
            type="button"
            className={styles.closeButton}
            aria-label={closeProps['aria-label']}
            title={closeProps.title}
            onClick={closeProps.onClick}
          >
            <X size={16} strokeWidth={2} aria-hidden />
          </button>
        ) : null}
      </div>

      <div className={styles.body} id="joyride-tooltip-content">
        {typeof content === 'string' ? <p>{content}</p> : content}
      </div>

      <div className={styles.footer}>
        {(showSkip || showBack) && (
          <div className={styles.footerStart}>
            <ButtonGroup>
              {showSkip ? (
                <Button onClick={skipProps.onClick}>{skipProps.title}</Button>
              ) : null}
              {showBack ? (
                <Button onClick={backProps.onClick}>{backProps.title}</Button>
              ) : null}
            </ButtonGroup>
          </div>
        )}
        {showPrimary ? (
          <div className={styles.footerEnd}>
            <Button variant="primary" onClick={primaryProps.onClick}>
              {primaryProps.title}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  )
}
